<script setup lang="ts">
import routes from '@routes';

import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t: translate } = useI18n();

export interface Props {
  error: { statusCode: number; message: string };
}

const props = defineProps<Props>();

const router = useRouter();
const route = router.currentRoute.value.path;

router.currentRoute.value.meta.title = translate('/error.page-title');
router.currentRoute.value.meta.layout = false;
</script>

<template>
  <div>
    <NuxtLayout name="sidebar" :title="translate('/error.page-title')">
      <div class="relative flex h-full w-full flex-col lg:flex-row">
        <div class="flex px-4">
          <div class="flex flex-col justify-start">
            <h1 class="relative mb-6 text-[160px] font-semibold leading-none text-blue-300">
              {{ props.error.statusCode }}
            </h1>
            <div class="weight-bold text-3xl font-semibold text-blue-900">
              {{ translate('/error.page-title') }}
            </div>
            <div v-if="error.statusCode === 404" class="text-base text-blue-900">
              <span>{{ translate('/error.error-message') }}</span>
              <br />
              <span>{{ route }}</span>
            </div>
            <div v-else class="text-base text-blue-900">
              <span>{{ error.message }}</span>
            </div>
            <div v-if="error.statusCode === 404" class="text-base text-blue-900" v-html="message" />
            <UIButton class="!mt-6 mb-4" @click.prevent="navigateTo({ name: routes.myRequests })">
              {{ translate('/error.nav-button') }}
            </UIButton>
          </div>
        </div>
        <!-- Note: this value is equal to the length of the 404 text. This way it does not get too small -->
        <div class="flex min-h-[361px] w-full grow bg-[url('/404.svg')] bg-contain bg-right-bottom bg-no-repeat" />
      </div>
    </NuxtLayout>
  </div>
</template>

<style scoped lang="css">
:deep(#content) {
  padding-bottom: 0;
  padding-right: 0;
}
</style>
